import { createAction, createReducer } from '@reduxjs/toolkit'

export const expandTitle = createAction<string>('arb-website/nav/expand-title')

export default createReducer<string>('', (builder) => {
  builder.addCase(expandTitle, (state, { payload }) => {
    return payload
  })
})
